// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3CEQX","content":"LayoutSettings_content__bIvZH"};